<ins-icon-container *ngFor="let icon of icons" [icon]="icon"></ins-icon-container>